import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule } from '@angular/material';
import { BaseService } from '../../shared/services/base.service';
import { PermissionService } from '../../shared/services/permission.service';
import { DialogService } from '../../shared/services/dialog.service';
import { DialogComponent } from '../../components/dialog/dialog.component';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
//import { UserUrl } from '../../../shared/urls/user.url';
import { __moduleName, CanDeactivateGuard } from '../../interfaces';
import { Utility } from '../../common/utility';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';

import { AuthHelper } from '../../common/auth.helper';
import { SelectCentreService } from './select-centre.service';

@Component({
  moduleId: __moduleName,
  selector: 'select-centre',
  templateUrl: 'select-centre.component.html',
  providers: [SelectCentreService]
})

export class SelectCentreComponent implements OnInit, AfterViewInit {
  public selectCentre: boolean = true;
  public inactiveTitle = AppMessages.dialog.successTitle;
  public inactiveMessage = AppMessages.centre.inactiveCentre;
  public centreForm: FormGroup;
  public defaultSelectOption = null;
  public navigateUrl = 'news';
  public centres: any;
  public centreName: any;

  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private router: Router,
    public baseService: BaseService,
    private selectCentreService: SelectCentreService,
    private permissionService: PermissionService) {

    this.createForm();
  }

  ngAfterViewInit() {

  }

  ngOnInit() {
    this.getUserCentre();
  }

  createForm() {
    this.centreForm = this.formBuilder.group({
      CentreId: [null, [Validators.required]],
      CountryId: ''
    });
  }

  getUserCentre() {
    this.selectCentreService.getUserCentre().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.centres = data;
          //show inactive layout when there are no centre
          if ( this.centres.length <= 0) {
            this.selectCentre = false;
          } else if (this.centres.length ==  1) {
            //auto redirect to news page
            this.getCentreData(this.centres[0].centreId);
          }
        }
      }
    );
  }

  onLogout() {
    this.baseService.logout();
  }

  getCentreData(centreId) {
    // Should use post to pass cases user input some invalid characters
    this.selectCentreService.getUserPermission(centreId).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            //localStorage.setItem(AppConstants.localStorage.userName, data.userName);

            //save centreId to localStorage
            localStorage.setItem(AppConstants.localStorage.centreId, centreId);
            //save countryId to localStorage
            let centre = this.centres.filter(c => c.centreId === centreId);
            localStorage.setItem(AppConstants.localStorage.centreName, centre[0].centreName );
            let countryId = centre.length > 0 ? centre[0].countryId : null;
            localStorage.setItem(AppConstants.localStorage.countryId, countryId);
            let isBaseClinic = centre.length > 0 ? centre[0].isBaseClinic : false;
            localStorage.setItem(AppConstants.localStorage.isBaseClinic, isBaseClinic);
            //save user Type to localStorage
            localStorage.setItem(AppConstants.localStorage.userType, data.roleName);
            //save user permission on pages
            localStorage.setItem(AppConstants.localStorage.permissionOnPage, data.permissions);
            this.permissionService.setPermissionOnPage(data.permissions);
            // save centre time zone
            localStorage.setItem(AppConstants.localStorage.centreTimeZoneOffset, data.timeZoneOffset);
            // reset data entry info
            this.baseService.setDataEntry(null, null);
            //navigate to news page
            this.router.navigate([this.navigateUrl]);
            localStorage.setItem(AppConstants.localStorage.centres, JSON.stringify(this.centres.map(x => { return { centreId: x.centreId, centreName: x.centreName }; })));
          }
        },
        error => {

        }
    );
  }

  onSubmitCentre(selectCentreForm: NgForm) {
    //submit selected centre
    this.centreName = this.centreForm.value["CentreId"]
    if (this.centreForm.dirty && this.centreForm.valid) {
      this.getCentreData(this.centreForm.value["CentreId"]);
    }
  }

}








// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/select-centre/select-centre.component.ts